import { Box, Callout, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { WizardStepLayout } from 'modules/banking/components/NewAccountModal/wizardSteps/WizardStepLayout'

interface Props {
  creationSource: string
}

const getProviderName = (creationSource: string): string => {
  switch (creationSource) {
    case 'expenses':
    case 'software':
    case 'benefits':
      return 'Stripe'
    case 'payments':
      return 'Swan'
    default:
      return ''
  }
}

export const ExternalOnboardingExplanationStep = ({ creationSource }: Props) => {
  const providerName = getProviderName(creationSource)

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.new_wizard.external_onboarding.title')}
      subtitle={i18n.t('banking.accounts.new_wizard.external_onboarding.subtitle', {
        provider: providerName,
      })}
    >
      <Box width="full" flexDirection="column" gap="s16" style={{ maxWidth: '500px' }}>
        <Text size="300" weight="semibold">
          {i18n.t('banking.accounts.new_wizard.external_onboarding.what_happens_title')}
        </Text>
        <Text size="300" weight="normal">
          {i18n.t('banking.accounts.new_wizard.external_onboarding.what_happens_description', {
            provider: providerName,
          })}
        </Text>

        <Text size="300" weight="semibold">
          {i18n.t('banking.accounts.new_wizard.external_onboarding.next_steps_title')}
        </Text>
        <Box flexDirection="column" gap="s8" paddingLeft="s16">
          <Text size="300">
            {i18n.t('banking.accounts.new_wizard.external_onboarding.step_1', {
              provider: providerName,
            })}
          </Text>
          <Text size="300">{i18n.t('banking.accounts.new_wizard.external_onboarding.step_2')}</Text>
          <Text size="300">{i18n.t('banking.accounts.new_wizard.external_onboarding.step_3')}</Text>
        </Box>

        <Callout
          title={i18n.t('banking.accounts.new_wizard.external_onboarding.info_title')}
          description={i18n.t('banking.accounts.new_wizard.external_onboarding.info_description')}
          type="info"
        />
      </Box>
    </WizardStepLayout>
  )
}
